import { render, staticRenderFns } from "./TreasurehuntPreviewObject.vue?vue&type=template&id=2d88e514&scoped=true&"
import script from "./TreasurehuntPreviewObject.vue?vue&type=script&lang=js&"
export * from "./TreasurehuntPreviewObject.vue?vue&type=script&lang=js&"
import style0 from "./TreasurehuntPreviewObject.vue?vue&type=style&index=0&id=2d88e514&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d88e514",
  null
  
)

export default component.exports